(ns frontend.view.components.pie-semi-circle-chart)

(defn options
  [{:keys [height size]} items]
  (clj->js {:chart       {:type         "pie"
                          :borderColor  "lightgray"
                          :borderRadius 10
                          :borderWidth  1
                          :plotShadow   false
                          :height       height}
            :title       {:text nil}
            :series      [{:data      items
                           :innerSize "50%"
                           :animation false}]
            :plotOptions {:pie {:dataLabels {:enabled  true
                                             :distance -50
                                             :style    {:fontWeight "bold"
                                                        :color      "white"}}
                                :size       size
                                :startAngle -90
                                :endAngle   90
                                :center     ["50%" "120%"]}}
            :tooltip     {:enabled false}
            :credits     {:enabled false}
            :legend      {:enabled false}}))
